import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Constants } from '../../constants/constants';
import { SendOtp } from '../../models/SendOtp';
import { VerifyOtp } from '../../models/VerifyOtp';
import { Repository } from '../../services/Repository';
import { TrackingService } from '../../services/TrackingService';
import { ToastService } from 'src/app/services/toastService';
import {environment} from 'src/environments/environment'
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {
  gsk: any = '@gsk.com';
  FG_Login: FormGroup;
  submitted: boolean = false;
  selectedLoginType: string = 'HCP';
  placeholder: string = 'Mobile OTP'
  MobileNo: any;
  options: boolean = true;
  OTP!: number;
  timerOn = true;

  DownTimeSecond: number = Constants.expireOtpTimeInSecond;
  interval: any;

  showTimeFp!: string;

  Password: any;

  inputMobileNo: any = '';
  plainText!: string;
  encryptText!: string;
  encPassword!: string;
  decPassword!: string;
  conversionEncryptOutput!: string;
  conversionDecryptOutput!: string;

  IsOtpVisibleFp: boolean = false;
  IsBtnResendVisibleFp: boolean = false;
  IsbtnVerifyUserVisibleFp: boolean = false;

  PublicKey: string = Constants.publicKey;
  otpExpired = Constants.msgOtpExpired;
  apiKey=environment.apiKey
  images = [
    {
      src: 'assets/images/India Boostrix logo.jpg',
      alt: 'Boostrix',
      url: `https://dev.api.gsk.com/Pharmatech/Vaxikart/RootApi/ProductImages/pdf/Boostrix_BTX-PI-IN-2023-01_clean%20copy_dated%2019-Jul-2023.pdf?apikey=${this.apiKey}`
    },
    {
      src: 'assets/images/India Fluarix Tetra logo with generic name.jpg',
      alt: 'Fluarix Tetra',
      url: `https://dev.api.gsk.com/Pharmatech/Vaxikart/RootApi/ProductImages/pdf/Fluarix%20Tetra%20NH%202024-25_FLXT-NH-PI-IN-2024-01_clean%20copy_dated%202-Apr-2024.pdf?apikey=${this.apiKey}`
    },
    {
      src: 'assets/images/India Infanrix Hexa Logo (1).jpg',
      alt: 'Infanrix Hexa',
      url: `https://dev.api.gsk.com/Pharmatech/Vaxikart/RootApi/ProductImages/pdf/Infanrix%20Hexa_IFX-H-PI-IN-2023-01_clean%20copy_dated%205-Apr-2023.pdf?apikey=${this.apiKey}`
    },
    {
      src: 'assets/images/Synflorix.png',
      alt: 'Synflorix',
      url: `https://dev.api.gsk.com/Pharmatech/Vaxikart/RootApi/ProductImages/pdf/Synflorix_SYN-PI-IN-2023-01_clean%20copy_dated%2019-Jul-2023.pdf?apikey=${this.apiKey}`
    },
    {
      src: 'assets/images/India Havrix logo.jpg',
      alt: 'Havrix',
      url: `https://dev.api.gsk.com/Pharmatech/Vaxikart/RootApi/ProductImages/pdf/Havrix_HAX-PI-IN-2023-01_clean%20copy_dated%2019-Jul-2023.pdf?apikey=${this.apiKey}`
    },
    {
      src: 'assets/images/India Varilrix logo.jpg',
      alt: 'Varilrix',
      url: `https://dev.api.gsk.com/Pharmatech/Vaxikart/RootApi/ProductImages/pdf/Varilrix_VRX%20PI-IN-2022-02_clean%20copy_dated%2004-Aug-2022.pdf?apikey=${this.apiKey}`
    }
  ];

  constructor(private forms: FormBuilder, private _repo: Repository, private _spinner: NgxSpinnerService, private _cookieService: CookieService
    , private _router: Router, private trackingService: TrackingService, private toastService: ToastService) {
    this.FG_Login = this.forms.group({
      loginType: ['HCP', Validators.required],
      MobileNo: [null, [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      Email: [null, [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9._%+-]+@gsk\.com$')  // Email validation for @gsk.com
      ]],
      OTP: [null, [Validators.required, Validators.pattern('^[0-9]{6}$')]],
    })
  }

  ngOnInit(): void {
    this.trackingService.trackEvent('Login-view', 'Load', '', 'Load Login view');
  }

  get f() {
    return this.FG_Login.controls;
  }

  startTimer() {
    this.DownTimeSecond = Constants.expireOtpTimeInSecond;
    this.interval = setInterval(() => {
      var seconds = this.DownTimeSecond;
      let rmainingTime = seconds;
      let minTime = 60;
      var minute = Math.floor(rmainingTime / minTime)
      rmainingTime = (rmainingTime - (minTime * minute));
      var second = Math.floor(rmainingTime)
      this.DownTimeSecond--;

      var lblShowTime: string = '';

      if (seconds >= 0) {
        if (minute >= 0 && second >= 0) {
          lblShowTime = '0' + minute + ':' + second + '';
        } else if (minute <= 0 && second >= 0) {
          lblShowTime = '00:' + second + '';
        }
        this.showTimeFp = lblShowTime;
      }
      else {
        lblShowTime = Constants.msgOtpExpired;
        this.showTimeFp = lblShowTime;
        this.IsBtnResendVisibleFp = true;
        if (this.IsBtnResendVisibleFp) {
          this.FG_Login.controls['MobileNo'].enable();
        }
      }
    }, 1000);
  }

  stopStartTimer() {
    clearInterval(this.interval);
  }


  ResetAllForm() {
    this.FG_Login.reset();
    this.submitted = false;
    this.IsOtpVisibleFp = false;
    this.IsBtnResendVisibleFp = false;
    this.IsbtnVerifyUserVisibleFp = false;
  }

  SendOTP() {
    this._spinner.show();
    this.trackingService.trackEvent('KYCLogin-view', 'SendOTP Button_Click', '' + this.FG_Login.controls['MobileNo'].value, 'Send OTP Button click');

    this.submitted = true;
    let sendOtp
    let mobileControl = this.FG_Login.controls['MobileNo'];  // Declare here
    let emailControl = this.FG_Login.controls['Email'];
    let Api: any = '';
    if (this.FG_Login.value.loginType === 'HCP') {
      Api = "Kyc/KYCSendOTP";
      let mobileControl = this.FG_Login.controls['MobileNo'];
      mobileControl.enable();
      if (mobileControl.invalid) {
        this._spinner.hide();
        return;
      }
      if (mobileControl.value == '0000000000') {
        this.toastService.showError('The provided mobile number appears to be invalid.');
        mobileControl.setValue('');
        this._spinner.hide();
        return;
      }
      sendOtp = new SendOtp();
      sendOtp.MobileNo = this.FG_Login.value.MobileNo;

      mobileControl.disable();
    }
    else {
      Api = "Kyc/KYCSendOTPRep";
      emailControl = this.FG_Login.controls['Email'];
      emailControl.enable();
      if (emailControl.invalid) {
        this._spinner.hide();
        return;
      }
      if (emailControl.value == '' || emailControl.value == ' ') {
        this.toastService.showError('The provided Email Id appears to be invalid.');
        emailControl.setValue('');
        this._spinner.hide();
        return;
      }
      sendOtp = new SendOtp();
      sendOtp.EmailId = this.FG_Login.value.Email;

      emailControl.disable();
    }
    // this.FG_Login.controls['loginType'].disable();

    this._repo.postMethodWithHeaderParamWC_WithoutToken(Api, sendOtp).subscribe((result: any) => {
      if (result.code == '400' || result.code == '824' || result.code == '825' || result.code == '500') {
        this.toastService.showError(result.message);
      }
      else if (result.code == '200') {
        if (this.FG_Login.value.loginType === 'HCP') {
          this.trackingService.trackEvent('KYCLogin-view', 'OTP sent successfully', '' + this.FG_Login.controls['MobileNo'].value, 'OTP sent successfully');
        }
        else {
          this.trackingService.trackEvent('KYCLogin-view', 'OTP sent successfully', '' + this.FG_Login.controls['Email'].value, 'OTP sent successfully');
        }
        this.stopStartTimer();
        this.startTimer();
        this.toastService.showSuccess(result.message);
        this.FG_Login.controls['OTP'].setValue('');
        this.IsOtpVisibleFp = this.IsOtpVisibleFp ? false : true;
        this.IsbtnVerifyUserVisibleFp = this.IsbtnVerifyUserVisibleFp ? false : true;
        if (this.FG_Login.value.loginType === 'HCP') {
          mobileControl.disable();
        }
        else {
          emailControl.disable();
        }
      }
      else {
        this.toastService.showError(Constants.msgSomethingWrong);
      }
      this._spinner.hide();
    }, error => { this._spinner.hide() });
  }

  KYCVerifyOTP() {
    this._spinner.show();
    this.trackingService.trackEvent('KYCLogin-view', 'KYCVerifyOTP Button_Click', '' + this.FG_Login.controls['MobileNo'].value, 'Verify OTP Button click');
    this.submitted = true
    let verifyOtp: any;
    let Api: any = '';
    if (this.selectedLoginType === 'HCP') {
      Api = "Kyc/KYCVerifyOTP";

      let mobileControl = this.FG_Login.controls['MobileNo'];
      mobileControl.enable();  // Make sure the mobile field is enabled for validation
      if (mobileControl.invalid) {
        this._spinner.hide();
        return;
      }

      verifyOtp = new VerifyOtp();
      verifyOtp.MobileNo = this.FG_Login.value.MobileNo;
      verifyOtp.OTP = this.FG_Login.value.OTP;
      mobileControl.disable();

    }
    if (this.selectedLoginType === 'Rep') {
      Api = "Kyc/KYCVerifyOTPRep";

      let emailControl = this.FG_Login.controls['Email'];
      emailControl.enable();
      if (emailControl.invalid) {
        this._spinner.hide();
        return;
      }
      verifyOtp = new VerifyOtp();
      verifyOtp.EmailId = this.FG_Login.value.Email;
      verifyOtp.OTP = this.FG_Login.value.OTP;
      emailControl.disable();
    }

    this._repo.postMethodWithHeaderParamWC_WithoutToken(Api, verifyOtp).subscribe((result: any) => {
      debugger
      if (result.code == '805' || result.code == '400' || result.code == '824' || result.code == '825' || result.code == '804') {
        this.toastService.showError(result.message);
      }
      else if (result.code == '200') {
        this.trackingService.trackEvent('KYCLogin-view', 'KYC otp verified ', '' + this.FG_Login.controls['MobileNo'].value, 'KYC otp verified');
        this.toastService.showSuccess(result.message);
        this.stopStartTimer();
        this.options = false;

        let user = {
          role: result.role,
          email: verifyOtp.EmailId ? verifyOtp.EmailId : '',
          mobileNo: verifyOtp.MobileNo ? verifyOtp.MobileNo : '',
          token: result.token
        }
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('role', JSON.stringify(result.role));
        this.selectedLoginType === 'Rep' ? localStorage.setItem('repEmail', JSON.stringify(verifyOtp.EmailId)) : null;
        this._cookieService.set('kyctoken', result.token, 0, '/', '', true, 'Lax');
        this._cookieService.set('KYCUserId', verifyOtp.MobileNo, 0, '/', '', true, 'Lax');
        if (this.selectedLoginType === 'Rep') {
          if (result.role === "REP_POB") {
            this._router.navigateByUrl('/homepage/hcpselection')
          }
          else if (result.role === 'REP_KYC') {
            this._router.navigateByUrl('/homepage/repkycdashboard')
          }
          else {
            this._router.navigateByUrl('/homepage')
          }
        }
        else {
          this._router.navigateByUrl('UserKycDashboard')
        }
        // this.selectedLoginType === 'Rep' ? this._router.navigateByUrl('/homepage') : this._router.navigateByUrl('UserKycDashboard');
      }
      else {
        this.toastService.showError(Constants.msgSomethingWrong);
      }
      this._spinner.hide()
    }, error => { this._spinner.hide() })
  }

  ResendOTP() {
    this._spinner.show();
    let mobileControl = this.FG_Login.controls['MobileNo'];
    let emailControl = this.FG_Login.controls['Email'];
    let sendOtp: SendOtp;
    let Api: string;

    // Log event for tracking
    if (this.FG_Login.value.loginType === 'HCP') {
      this.trackingService.trackEvent('KYCLogin-view', 'ResendOTP Button_Click', '' + this.FG_Login.controls['MobileNo'].value, 'ReSend OTP Button Click');
    } else {
      this.trackingService.trackEvent('KYCLogin-view', 'ResendOTP Button_Click', '' + this.FG_Login.controls['Email'].value, 'ReSend OTP Button Click');
    }

    this.submitted = true;

    // For HCP login type (MobileNo)
    if (this.FG_Login.value.loginType === 'HCP') {
      mobileControl.enable();  // Enable mobile field before validation

      if (mobileControl.invalid) {
        this._spinner.hide();
        return;
      }

      if (mobileControl.value === '0000000000') {
        this.toastService.showError('The provided mobile number appears to be invalid.');
        mobileControl.setValue('');
        this._spinner.hide();
        return;
      }

      sendOtp = new SendOtp();
      sendOtp.MobileNo = mobileControl.value;

      Api = "Kyc/KYCSendOTP";  // Use the API for HCP

      mobileControl.disable();  // Disable mobile field after sending the OTP

    }
    // For Rep login type (Email)
    else {
      emailControl.enable();  // Enable email field before validation

      if (emailControl.invalid) {
        this._spinner.hide();
        return;
      }

      if (emailControl.value.trim() === '') {
        this.toastService.showError('The provided email address appears to be invalid.');
        emailControl.setValue('');
        this._spinner.hide();
        return;
      }

      sendOtp = new SendOtp();
      sendOtp.EmailId = emailControl.value;

      Api = "Kyc/KYCSendOTPRep";  // Use the API for Rep

      emailControl.disable();  // Disable email field after sending the OTP
    }
    this._repo.postMethodWithHeaderParamWC_WithoutToken(Api, sendOtp).subscribe((result: any) => {
      if (result.code === '400' || result.code === '824' || result.code === '825' || result.code === '500') {
        this.toastService.showError(result.message);
      } else if (result.code === '200') {
        // Track successful OTP send
        if (this.FG_Login.value.loginType === 'HCP') {
          this.trackingService.trackEvent('KYCLogin-view', 'OTP sent successfully', '' + this.FG_Login.controls['MobileNo'].value, 'OTP sent successfully');
        } else {
          this.trackingService.trackEvent('KYCLogin-view', 'OTP sent successfully', '' + this.FG_Login.controls['Email'].value, 'OTP sent successfully');
        }

        // Reset OTP input field and start timer
        this.FG_Login.controls['OTP'].setValue('');
        this.showTimeFp = "";
        this.stopStartTimer();
        this.startTimer();

        this.toastService.showSuccess(result.message);

        // Toggle the visibility of OTP input and Verify button
        this.IsOtpVisibleFp = true;
        this.IsbtnVerifyUserVisibleFp = true;

      } else {
        this.toastService.showError(Constants.msgSomethingWrong);
      }

      // Hide the spinner after the API call
      this._spinner.hide();
    }, error => {
      this._spinner.hide();
      this.toastService.showError('An error occurred. Please try again.');
    });
  }

  onLoginTypeChange(loginType: string) {
    this.selectedLoginType = loginType;

    // Reset buttons visibility
    this.IsOtpVisibleFp = false; // Hide OTP input
    this.IsBtnResendVisibleFp = false; // Hide Resend OTP button
    this.IsbtnVerifyUserVisibleFp = false; // Hide Verify OTP button

    // Reset OTP timer
    this.stopStartTimer();
    this.FG_Login.controls['OTP'].setValue(''); // Reset OTP field value

    // Reset MobileNo and Email validators based on login type
    if (loginType === 'Rep') {
      this.placeholder = 'Email OTP'
      this.FG_Login.controls['Email'].setValidators([
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9._%+-]+@gsk\.com$')
      ]);
      this.FG_Login.controls['MobileNo'].clearValidators(); // Clear mobile validation
      this.FG_Login.controls['Email'].updateValueAndValidity();
      this.FG_Login.controls['MobileNo'].disable(); // Disable MobileNo input
      this.FG_Login.controls['Email'].enable(); // Enable Email input
    } else {
      this.placeholder = 'Mobile OTP'

      this.FG_Login.controls['MobileNo'].setValidators([
        Validators.required,
        Validators.pattern('^[0-9]{10}$')
      ]);
      this.FG_Login.controls['Email'].clearValidators(); // Clear email validation
      this.FG_Login.controls['MobileNo'].updateValueAndValidity();
      this.FG_Login.controls['Email'].disable(); // Disable Email input
      this.FG_Login.controls['MobileNo'].enable(); // Enable MobileNo input
    }

    // Ensure "Send OTP" button is visible initially when not in OTP phase
    this.IsOtpVisibleFp = false;
    this.IsBtnResendVisibleFp = false;
    this.IsbtnVerifyUserVisibleFp = false;

    // Reset form submission state
    this.submitted = false;
  }

}